// extracted by mini-css-extract-plugin
export default {"footer":"PortfolioResendFaxPopup_footer__P-hfg"};